import { connect } from 'react-redux';

import { getItemsList } from '../Items/itemsActions';
import {
  getOfficesShortList,
  getPublicZoneList,
} from '../Offices/officesActions';
import ItemsCountingDashboard from './ItemsCountingDashboard';
import { getItemCountingDashboardData } from './ItemsCountingDashboardActions';

const mapStateToProps = state => ({
  officesShortList: state.office.officesShortList,
  itemsList: state.items.itemsList,
  publicZoneList: state.office.publicZoneList,
  itemCountingDashboardData: state.items.itemCountingDashboardData,
  isLoading: state.items.isCountingDashboardDataLoading,
});
const mapDispatchToProps = dispatch => ({
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getItemsList: params => dispatch(getItemsList(params)),
  getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  getItemCountingDashboardData: params =>
    dispatch(getItemCountingDashboardData(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItemsCountingDashboard);
